import SimulationPricingsDailyBenefitForm from './SimulationPricingsDailyBenefitForm';
import { Loading } from '@fasstech/middle-design-system';
import useGetSimulationPricingsDailyBenefitQuery from './hooks/useGetSimulationPricingsDailyBenefitQuery';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures';

const SimulationPricingsDailyBenefit = ({ getMiddleText, getMiddleBoolean }) => {
  const { getSimulationPricingsDailyBenefit, loading: isLoadingGetSimulationPricingsDailyBenefit } =
    useGetSimulationPricingsDailyBenefitQuery();

  if (isLoadingGetSimulationPricingsDailyBenefit) return <Loading />;
  return (
    <div>
      <SimulationPricingsDailyBenefitForm
        getSimulationPricingsDailyBenefit={getSimulationPricingsDailyBenefit}
        getMiddleBoolean={getMiddleBoolean}
        getMiddleText={getMiddleText}
      />
    </div>
  );
};

export default withMiddleFeatures(SimulationPricingsDailyBenefit);
